import api from "./api";

export interface LightPresetGroupAvailableTimeRow {
  id: string;
  weekday: number;
  startTime: string;
  endTime: string;
  sortOrder: number;
}

export interface LightPresetGroupAvailableTimesPayload {
  windows: LightPresetGroupAvailableTimeRow[];
}

export type LightPresetGroupRow = {
  id: string;
  alias: string | null;
  overridePresetAvailableTimes: boolean;
};

export type LightPresetGroupPatch = {
  alias?: string | null;
  overridePresetAvailableTimes?: boolean;
};

export const lightPresetGroupsApi = {
  getById: async (lightPresetGroupId: string): Promise<LightPresetGroupRow> => {
    const { data } = await api.get<LightPresetGroupRow>(
      `/light-preset-groups/${lightPresetGroupId}`,
    );
    return data;
  },

  patch: async (
    lightPresetGroupId: string,
    body: LightPresetGroupPatch,
  ): Promise<LightPresetGroupRow> => {
    const { data } = await api.patch<LightPresetGroupRow>(
      `/light-preset-groups/${lightPresetGroupId}`,
      body,
    );
    return data;
  },

  /** @deprecated Use patch() */
  patchAlias: async (
    lightPresetGroupId: string,
    alias: string | null,
  ): Promise<LightPresetGroupRow> => {
    return lightPresetGroupsApi.patch(lightPresetGroupId, { alias });
  },

  getAvailableTimes: async (
    lightPresetGroupId: string,
  ): Promise<LightPresetGroupAvailableTimeRow[]> => {
    const { data } = await api.get<LightPresetGroupAvailableTimesPayload>(
      `/light-preset-groups/${lightPresetGroupId}/available-times`,
    );
    return data.windows ?? [];
  },

  putAvailableTimes: async (
    lightPresetGroupId: string,
    windows: { weekday: number; startTime: string; endTime: string }[],
  ): Promise<LightPresetGroupAvailableTimeRow[]> => {
    const { data } = await api.put<LightPresetGroupAvailableTimesPayload>(
      `/light-preset-groups/${lightPresetGroupId}/available-times`,
      { windows },
    );
    return data.windows ?? [];
  },
};

